import { TranslationKey } from 'intl';
import { RichTextTranslationKeys } from 'intl/keys';
import { Color } from 'shared/utils/colors';
import { normalizeTextColor } from 'shared/utils/richText';

export interface NamedTextColor {
  /** `#RRGGBB`, as the editor stores it. */
  color: string;
  nameKey: TranslationKey;
}

const named = (color: Color, nameKey: TranslationKey): NamedTextColor => ({
  color: normalizeTextColor(color) ?? color,
  nameKey,
});

/**
 * The basic text colours (PT-7250), from the app's palette: all legible on a
 * white page and in the PDF report.
 */
export const BASIC_TEXT_COLORS: readonly NamedTextColor[] = [
  named(Color.black, RichTextTranslationKeys.richtextColorBlack),
  named(Color.slateGray, RichTextTranslationKeys.richtextColorGray),
  named(Color.errorRedDark, RichTextTranslationKeys.richtextColorDarkRed),
  named(Color.red, RichTextTranslationKeys.richtextColorRed),
  named(Color.warningOrange, RichTextTranslationKeys.richtextColorOrange),
  named(
    Color.primaryOrangeDark,
    RichTextTranslationKeys.richtextColorDarkYellow
  ),
  named(
    Color.successGreenDark,
    RichTextTranslationKeys.richtextColorDarkGreen
  ),
  named(Color.accentGreen600, RichTextTranslationKeys.richtextColorGreen),
  named(Color.blue, RichTextTranslationKeys.richtextColorBlue),
  named(Color.purple, RichTextTranslationKeys.richtextColorPurple),
];

/** What the "A" applies before the user picked any colour, as in word processors. */
export const DEFAULT_TEXT_COLOR =
  normalizeTextColor(Color.red) ?? Color.red;
